import * as React from 'react';
import { Route } from 'react-router';
import { MParticlePageName } from '@reverbdotcom/commons/dist/elog/mparticle_tracker';

export default (
  <Route
    key="holiday"
    path="holiday"
    props={{
      pageViewEvent: {
        pageName: MParticlePageName.Holiday,
      },
    }}
    getComponent={(_location, cb) => {
      require.ensure(
        [],
        (require) => {
          cb(null, require('../components/discovery/holiday_sale_grid').HolidaySaleGrid);
        },
        'marketplace',
      );
    }}
  />
);
